<template>
  <div id="allDeviceDetail">
    <!-- 设备信息--设备信息图表、设备信息详情 -->
    <el-row :gutter="40" style="margin-bottom: 20px;">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <div class="headTitle">
          <span style="font-size: 20px;margin-right: 20px;">{{ basicinfo.deviceName }}</span>
          <span style="font-size: 18px;margin-right: 20px;">({{ basicinfo.deviceSn }})</span>
          <span class="fontStyle2" />
          <span class="fontStyle1">{{ $t("yhubReport.FirmwareVersion") }}:V{{ basicinfo.fwVersion }}</span><!--固件-->
          <el-button 
          v-if="basicinfo.customerServiceNum&&basicinfo.customerServiceNum>0" 
          class="feedBackBtn" type="primary" icon="el-icon-more" :title="$t('feedBack.deviceUnresolved')" @click="gotoFeedBack">
            
          </el-button>
          <el-button class="deviceInfoDetailBtn" icon="el-icon-edit " style="right:20px;" type="primary" @click="showEditBasicinfoPop" />
        </div>
      </el-col>
    </el-row>
    <eveF477Tem :mcu-id="$route.query.mcuId" :sn="basicinfo.deviceSn" />

    <!--编辑基本信息弹窗 -->
    <el-dialog id="editBasicinfoPop" :close-on-click-modal="false" :visible.sync="editBasicinfoPop" width="80%">
      <el-form ref="editBasicinfoPop" :inline="true" :model="editBasicinfo" :rules="rules" label-position="right" label-width="180px">
        <el-row :gutter="40">
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.SN')" prop="deviceSn">
              <!--序列号-->
              <el-input v-model="editBasicinfo.deviceSn" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('dashboard.DeviceName')" prop="deviceName">
              <!--设备名称-->
              <el-input v-model="editBasicinfo.deviceName" :placeholder="$t('BondOrUpdateDevice.PleaseEnterAName')" @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <!-- 编辑时，型号和容量不做必填校验 -->
            <el-form-item :label="$t('BondOrUpdateDevice.Model')">
              <!-- 电池型号 -->
              <el-cascader v-model="batteryCascader" :disabled="true" :options="options2" :placeholder="editBasicinfo.batteryBrand + '/' + editBasicinfo.batteryModel" :show-all-levels="true" style="width: 200px" @change="batteryModelChange" />
              <p v-show="isShowBatteryModelWarning" class="redWarningFont">{{ $t('BondOrUpdateDevice.SelectBattery') }}</p>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('basicinfo.SystemVoltage')">
              <!--系统电压-->
              <el-input v-model="editBasicinfo.batteryVoltage" :disabled="true" :placeholder="$t('BondOrUpdateDevice.PleaseSelectOperatingVoltage')" @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.Capacity')">
              <!--容量-->
              <el-input v-model="editBasicinfo.batteryCapacity" :disabled="true" :placeholder="$t('BondOrUpdateDevice.EnterBatteryCapacity')" @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.OwnedCompany')" prop="company">
              <!--归属公司-->
              <el-select v-model="editBasicinfo.company" :placeholder="editBasicinfo.companyName" class="filter-item" clearable filterable @change="change($event)">
                <el-option v-for="(item,index) in companyOptions" :key="index" :label="item.label" :value="item.key" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.Machine')+$t('adminView.Brand')">
              <!--品牌-->
              <!-- <el-select v-model="editBasicinfo.mechBrand" :placeholder="$t('BondOrUpdateDevice.Machine')+$t('adminView.Brand')" class="filter-item" clearable filterable>
                <el-option v-for="(item,index) in machineBrandOptions" :key="index" :label="item" :value="item" />
              </el-select> -->
              <el-autocomplete v-model="editBasicinfo.mechBrand" class="inline-input" :fetch-suggestions="queryMechBrand" :placeholder="$t('BondOrUpdateDevice.Machine')+$t('adminView.Brand')" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.Machine')+$t('adminView.Type')">
              <!--类型-->
              <el-select v-model="editBasicinfo.mechType" :placeholder="$t('BondOrUpdateDevice.Machine')+$t('adminView.Type')" class="filter-item" clearable filterable @change="change($event)">
                <el-option v-for="(item,index) in machineTypeOptions" :key="index" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 机器型号 -->
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.Machine')+$t('adminView.Model2')">
              <el-input v-model="editBasicinfo.mechModel" :placeholder="$t('BondOrUpdateDevice.Machine')+$t('adminView.Model2')" @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('allDeviceDetail.BindingTime')" prop="restTime">
              <!--绑定时间-->
              <el-input v-model="editBasicinfo.resetTime" :disabled="true" />
              <el-button class="deviceInfoDetailBtn" icon="el-icon-refresh" type="primary" @click="showUpdateTimePop" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col cellNumber">
            <el-form-item :label="$t('AllDevices.cellNumber')" prop="cell">
              <el-input v-model="editBasicinfo.cell" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
              <i class="el-icon-question" @mouseover="isShowCellNumPop=true" @mouseout="isShowCellNumPop=false" />
            </el-form-item>
            <div v-if="isShowCellNumPop" class="cellNumberInfoPop">
              <p>{{ $t('allDeviceDetail.cellNumberInfo') }}</p>
            </div>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col cellNumber">
            <el-form-item :label="$t('dashboard.SiteName')">
              <el-autocomplete v-model="editBasicinfo.site" class="inline-input" :fetch-suggestions="querySearchCity" :placeholder="$t('dashboard.SiteName')" @select="handleSelect" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('AllDevices.GPS')" prop="batterySystemVolt">
              <el-switch v-model="LocationOrNot" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('allDeviceDetail.RemainingTime')">
              <el-switch v-model="editBasicinfo.showAvailableTime" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('AllDevices.IgnitionReport')">
              <el-switch v-model="editBasicinfo.hourMeterStatus" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" />
            </el-form-item>
          </el-col>
          <el-col v-if="editBasicinfo.hourMeterStatus" :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('AllDevices.IgnitionVoltage')" prop="openIgnitionVol">
              <el-input v-model="editBasicinfo.openIgnitionVol" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col v-if="editBasicinfo.hourMeterStatus" :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('AllDevices.UseVoltageTh')" prop="workHourmeterVol">
              <el-input v-model="editBasicinfo.workHourmeterVol" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="12" class="card-panel-col">
            <el-form-item :label="$t('AllDevices.HalfV')">
              <el-switch v-model="editBasicinfo.halfV" :active-text="$t('location.enable')" :inactive-text="$t('location.disable')" @change="change($event)" />
            </el-form-item>
          </el-col>
          <div v-if="false">
            <el-col :lg="24" :sm="12" :xs="12" class="card-panel-col setting">
              <!--其他设置-->
              <el-form-item :label="$t('BondOrUpdateDevice.Advanced')" label-width="120px" @click.native="isShowSetting=!isShowSetting">
                <p v-show="isShowWarnIcon" style="font-size: 14px;color: red;">「 {{ $t('allDeviceDetail.UpdateFailed') }} 」</p>
              </el-form-item>
            </el-col>
            <div v-show="isShowSetting">
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.EquipmentType')">
                  <!--设备类型-->
                  <el-checkbox-group v-model="deviceTypeArr">
                    <el-checkbox v-for="(item,index) in deviceTypeOptions" :key="index" :disabled="item.disabled" :label="item.value">{{ item.label }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('CAN')" prop="canFuntion">
                  <!--CAN类型-->
                  <!-- /<el-input v-model="editBasicinfo.canFuntion" :placeholder="canFuntion" width="120px" @input="change($event)" /> -->
                  <template class="ycdd">
                    <el-select v-model="editBasicinfo.canFuntion" placeholder="请选择" @input="change($event)">
                      <el-option v-for="item in canOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.LevelSensor')">
                  <!--液位采集-->
                  <el-radio v-model="editBasicinfo.supportWaterlevel" :label="1" @input="change($event)">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
                  <el-radio v-model="editBasicinfo.supportWaterlevel" :label="0" @input="change($event)">{{ $t('BondOrUpdateDevice.No') }}</el-radio>
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.LEDIndicator')">
                  <!--面板指示灯-->
                  <el-radio v-model="editBasicinfo.ledSetting" :label="1" @input="change($event)">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
                  <el-radio v-model="editBasicinfo.ledSetting" :label="2" @input="change($event)">{{ $t('BondOrUpdateDevice.No') }}</el-radio>
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.SensorType')">
                  <!--电流计类型-->
                  <el-radio v-model="editBasicinfo.sensorType" :label="2" @change="sensorTypeChange" @input="change($event)">SHUNT</el-radio>
                  <el-radio v-model="editBasicinfo.sensorType" :label="1" @change="sensorTypeChange" @input="change($event)">HALL</el-radio>
                  <el-radio v-show="isShowHallDetail" v-model="editBasicinfo.hallDirection" :label="1" @change="sensorTypeChange" @input="change($event)">{{ $t('BondOrUpdateDevice.Forward') }}</el-radio>
                  <el-radio v-show="isShowHallDetail" v-model="editBasicinfo.hallDirection" :label="2" @change="sensorTypeChange" @input="change($event)">{{ $t('BondOrUpdateDevice.Reverse') }}</el-radio>
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.Track')" class="ycdd" prop="extralFuntion">
                  <!--运动轨迹-->
                  <el-radio v-model="editBasicinfo.extralFuntion" :label="1" @input="change($event)">{{ $t('BondOrUpdateDevice.Off') }}</el-radio>
                  <el-radio v-model="editBasicinfo.extralFuntion" :label="2" @input="change($event)">{{ $t('BondOrUpdateDevice.On') }}</el-radio>
                  <el-input v-show="editBasicinfo.extralFuntion==2" v-model="editBasicinfo.locationSample" type="text" @input="change($event)" />
                  <span v-show="editBasicinfo.extralFuntion==2">{{ $t('BondOrUpdateDevice.SecondsTimes') }}</span>
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('BondOrUpdateDevice.RemoteControl')">
                  <!--远程断电-->
                  <el-radio v-model="editBasicinfo.supportRelaycontrol" :label="0" @input="change($event)">{{ $t('BondOrUpdateDevice.No') }}</el-radio>
                  <el-radio v-model="editBasicinfo.supportRelaycontrol" :label="1" @input="change($event)">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
                  <!-- <el-input v-model="editBasicinfo.locationSample" type="text" />{{ $t('BondOrUpdateDevice.SecondsTimes') }} -->
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item label="APN">
                  <p>{{ editBasicinfo.gprsApnName }}</p>
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('allDeviceDetail.resetFunction')">
                  <el-button class="filter-item" type="primary" @click="restoreFactorySet">{{ $t('allDeviceDetail.startReset') }}</el-button>
                </el-form-item>
              </el-col>
            </div>
          </div>
          <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
            <el-form-item style="text-align: end;">
              <el-button @click="editBasicinfoPop = false">{{ $t('button.Cancel') }}</el-button>
              <!---->
              <el-button class="filter-item" type="primary" @click="submitBasicinfo('editBasicinfoPop')">{{ $t('button.Submit') }}</el-button>
              <!---->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!--恢复出厂设置弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="restoreFactorySetPop" width="60%">
      <el-form ref="restoreFactorySetPop" :inline="true" :model="restoreFactorySetInfo" :rules="rules1" label-position="right" label-width="150px">
        <el-row :gutter="40">
          <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('BondOrUpdateDevice.Passcode')" prop="passcode">
              <el-input v-model="restoreFactorySetInfo.passcode" :placeholder="$t('BondOrUpdateDevice.EnterNumbers')" @blur="blurPasscode" @input="change($event)" />
              <p>{{ findPC }}</p>
              <p v-show="isShowResFacSetInfoPasscode" class="redWarningFont">{{ $t('BondOrUpdateDevice.IncorrectPasscode') }}</p>

              <!-- <p v-show="isShowResFacSetInfoPasscode" style="font-size: 14px;color: red;">「 {{ $t('allDeviceDetail.UpdateFailed') }} 」</p> -->
            </el-form-item>
          </el-col>
          <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
            <el-form-item style="text-align: end;">
              <el-button @click="restoreFactorySetPop = false">{{ $t('button.Cancel') }}</el-button>
              <!---->
              <el-button class="filter-item" type="primary" @click="submitRestoreFactorySet('editBasicinfoPop')">{{ $t('button.Submit') }}</el-button>
              <!---->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

import { deviceBattery, findDeviceInfo, sysDictInfo, getLastOne, getGNSSLastByMcuID, updateDeviceBindBase, listByCompanyParentId, getRealTimeInfo2, getLastRealTimeData, getHourMeterTotalTime, addDeviceReset, addDeviceAllReset, getGnssConfig, updateGnssConfig, cascader, deviceMechcascader, machineTypeList, getCompanySiteList } from '@/api/allDevice'
import { GetRealTimeData } from '@/api/leaseManagement'
import { getDateAndHour, howLongAgo2, usedTime, howLongAgo } from '@/utils/updateTime.js'
import eveF477Tem from './components/eveF477Tem'
import i18n from '@/i18n'
import { arrObjSort } from '@/utils/arrayFun.js'
import vPinyin from '@/utils/pinyin-vue.js'

export default {
  name: 'DashboardAdmin',
  components: {
    eveF477Tem
  },
  data() {
    return {
      // 地图----start
      LocationOrNot: false,
      height: '700px',
      value1: false, //  是否显示高德地图 true：高德 false：谷歌
      locationList: [], // 地图要描点的集合
      isShowMapFloat: false, // 是否显示图示
      haveLocationInfo: true, // 是否有定位信息
      // 地图----end
      onlyGPS: false,
      basicinfo: {},
      createTime: null,
      pidSeriesData: 0,
      rateHeight: '250px',
      showFirstPie: true,
      pieSeriesDataName: 'WH',
      pieSeriesData: [
        { name: 'Charged', value: 0 },
        { name: 'Discharged', value: 0 }
      ],
      pieSeriesData2: [
        { name: 'Charged', value: 0, dw: 'Wh' }, // dw:单位
        { name: 'Discharged', value: 0, dw: 'Wh' }
      ],
      colorArr2: ['#a9d252', '#1e90fc'],
      isShowSohEchart: true, // soh图表是否显示
      // 警告
      warningList1: [
        { name: '电量低', isColor: 'false', imgUrl: require('@/assets/images/battery_gray.png') },
        { name: '电压低', isColor: 'false', imgUrl: require('@/assets/images/locbatt_gray.png') },
        { name: '液位低', isColor: 'false', imgUrl: require('@/assets/images/water_gray.png') },
        { name: '温度高', isColor: 'false', imgUrl: require('@/assets/images/toohot_gray.png') }
      ],
      warningList2: [
        { name: '电量低', isColor: 'false', imgUrl: require('@/assets/images/battery_gray.png') },
        { name: '电压低', isColor: 'false', imgUrl: require('@/assets/images/locbatt_gray.png') },
        { name: '温度高', isColor: 'false', imgUrl: require('@/assets/images/toohot_gray.png') },
        { name: 'SOH差', isColor: 'false', imgUrl: require('@/assets/images/soh_gray.png') },
        { name: '不在设定区域', isColor: 'false', imgUrl: require('@/assets/images/position_gray.png') }
      ],
      isShowWarnIcon: false, // 是否显示感叹号
      editUpdateTimePop: false,
      editUpdateTime: {},
      value2: '',
      batteryInfo: {
        cell: 0,
        batteryVoltage: null,
        current: null,
        batteryTmp: null,
        soc: null,
        level: null,
        halfVOnOrOff: null, // 是否开启半电压
        hourMeterOnOrOff: null,
        openIgnitionVol: null,
        Ignition: null,
        workHourmeterVol: null,
        hourMeter: null,
        chargingWh: '--',
        usingWh: '--',
        remainingAvailableTime: 0
      }, // 电池状态--详细信息
      myDeviceType: '0', // 设备类型 1-充电器 4-逆变器 5-锂电池
      batteryStatus: 0, // 电池状态 ['IDLE', 'CHARGING', 'DISCHARGING'], // 静止，充电，放电
      mcuid: this.$route.query.mcuId,
      updateTime: null,
      warningList: [],
      lithiumUpdateTime: null, // 锂电池最后更新时间
      machineBrandOptions: [], // 设备品牌
      machineTypeOptions: [], // 设备类型

      // 编辑设备信息弹窗----start
      editBasicinfoPop: false, // 编辑基本信息弹窗
      editBasicinfo: {
        locationSample: '60',
        batteryVoltage: '24',
        batteryCapacity: null,
        supportWaterlevel: null,
        ledSetting: null,
        sensorType: null,
        hallDirection: null,
        extralFuntion: null,
        supportRelaycontrol: null,
        deviceSn: null,
        mechBrand: null,
        mechModel: null,
        deviceName: null,
        batteryBrand: null,
        batteryModel: null,
        company: null,
        resetTime: null,
        showAvailableTime: false,
        hourMeterStatus: false,
        openIgnitionVol: null,
        workHourmeterVol: null,
        halfV: false,
        site: ''
      },
      rules: {
        deviceName: [{ required: true, message: i18n.t('allDeviceDetail.DeviceNameCannotEmpty'), trigger: 'blur' }], // 设备名称不能为空
        deviceSn: [{ required: true, message: i18n.t('BondOrUpdateDevice.SNNotFound'), trigger: 'blur' }], // 序列号不能为空
        mcuId: [{ required: true, message: 'mcuId不能为空', trigger: 'blur' }],
        passcode: [{ required: true, message: i18n.t('BondOrUpdateDevice.IncorrectPasscode'), trigger: 'blur' }], // 激活码不能为空
        cell: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }]
        // batteryCapacity: [{ required: true, message: i18n.t('BondOrUpdateDevice.EnterBatteryCapacity'), trigger: 'blur' }], // 容量不能为空
        // batteryVoltage: [{ required: true, message: i18n.t('BondOrUpdateDevice.PleaseSelectOperatingVoltage'), trigger: 'blur' }] // 系统电压不能为空
        // owncompany: [{ required: true, message: '归属公司不能为空', trigger: 'change' }]
      },
      rules1: {
        passcode: [{ required: true, message: i18n.t('BondOrUpdateDevice.IncorrectPasscode'), trigger: 'blur' }] // 激活码不能为空
      },
      allCity: [],
      companyOptions: [], // 编辑设备信息弹窗--归属公司下拉框
      options3: [], // 编辑设备信息弹窗--设备信息（品牌型号）下拉框
      options2: [], // 编辑设备信息弹窗--电池型号下拉框
      deviceTypeOptions: [], // 编辑设备信息弹窗--设备信息多选框
      deviceTypeArr: [], // 选中的设备类型
      isShowHallDetail: false,
      getLastYhubConfig: {},
      isShowSetting: false,
      isShowBatteryModelWarning: false,
      batteryInfoPop: null,
      restoreFactorySetPop: false, // 恢复出厂设置弹窗
      restoreFactorySetInfo: {},
      isShowResFacSetInfoPasscode: false, // 提示不能为空
      canOptions: [
        { value: 0, label: '0 YHUB' },
        { value: 1, label: '1 doogle' },
        { value: 2, label: '2 pgt' },
        { value: 3, label: '3 hsm' },
        { value: 4, label: '4 Kisae' },
        { value: 5, label: '5 BMS' },
        { value: 6, label: '6 GPD' },
        { value: 7, label: '7 hoppecke' },
        { value: 8, label: '8 EVE_BMS' },
        { value: 9, label: '9 SinoboomCAN' },
        { value: 10, label: '10 EVE_F477' },
        { value: 11, label: '11 Yhub_info' }
      ],
      // 编辑基本信息弹窗----end
      findPC: null,
      oldbatterySystemVolt: '',
      oldbatteryTotalah: '',
      oldbatteryId: '',
      batteryCascader: [],
      isShowMap: true,
      basic: {
        IgnitionTime: 0,
        IgnitionTimeZh: 0,
        hourMeterTime: 0,
        hourMeterTimeZh: 0,
        Ignition: '--',
        hourMeter: '--',
        otherInput1: '--',
        otherInput2: '--',
        AnalogTime: '--'
      },
      isShowCellNumPop: false,
      communication485: 1// 判断485模块是否展示 2展示 1不展示
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.queryList()
    }
    // editBasicinfo: {
    //   handler(newValue, oldValue) {
    //     this.editBasicinfo = newValue // 把新值赋值给我们的属性数据
    //   },
    //   deep: true
    // }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  mounted() {
    this.queryList()
    this.popInit()
    GetRealTimeData({ mcuId: this.$route.query.mcuId }).then(res => {})
    this.getLastOne()// 根据配置里的485通讯是否打开，判断是否展示485模块内容
    // console.log('yhubRequest', this.yhubRequest)
    // console.log('yhubRequest', JSON.parse(sessionStorage.getItem('yhubRequest')))
    // console.log(this.$store)
  },
  created() {
    // this.yhubRequest = JSON.parse(sessionStorage.getItem('yhubRequest'))
  },
  methods: {
    queryList() {
      var param = {
        mcuId: this.$route.query.mcuId
      }
      if (this.$route.query.deviceType.indexOf('e') > -1) {
        // 锂电池
        this.isShowSohEchart = false
      } else {
        this.isShowSohEchart = true
      }
      // 设备信息
      findDeviceInfo(param).then(res => {
        // 设备信息详情
        this.basicinfo = res.resultModel
        this.batteryInfo.cell = res.resultModel.cell
        this.batteryInfo.halfVOnOrOff = res.resultModel.halfV == 1
        this.batteryInfo.hourMeterOnOrOff = res.resultModel.hourMeterStatus == 1
        this.editBasicinfo.showAvailableTime = res.resultModel.showAvailableTime == 1
        this.editBasicinfo.halfV = res.resultModel.halfV == 1
        this.editBasicinfo.site = res.resultModel.site
        if (this.basicinfo.batteryVoltage) { this.basicinfo.batteryVoltage = this.basicinfo.batteryVoltage > 100 ? this.basicinfo.batteryVoltage / 100 : this.basicinfo.batteryVoltage }
        if (this.basicinfo.cell) { this.basicinfo.CellVoltage = (this.basicinfo.batteryVoltage / this.basicinfo.cell).toFixed(2) } else { this.basicinfo.CellVoltage = '--' }
        if (this.basicinfo.batteryCapacity) { this.basicinfo.batteryCapacity = this.basicinfo.batteryCapacity > 1000 ? this.basicinfo.batteryCapacity / 100 : this.basicinfo.batteryCapacity }
        if (res.resultModel.resetTime) {
          this.createTime = getDateAndHour(res.resultModel.resetTime, 'noTime') // 绑定时间
          this.basicinfo.lastUpdateTime = howLongAgo2(new Date(res.resultModel.resetTime).getTime())
        }
        this.findPC = i18n.t('allDeviceDetail.findPC1') + this.basicinfo.deviceSn + i18n.t('allDeviceDetail.findPC2')
        this.myDeviceType = this.$route.query.deviceType // 电池状态组件--设备类型
        // this.myDeviceType = '0,4'// 电池状态组件--设备类型
        // console.log('deviceType', this.$route.query.deviceType)
        // 编辑基本信息弹窗--获取电池信息
        deviceBattery({ id: this.basicinfo.batteryId }).then(response => {
          this.batteryInfoPop = response.resultModel
        })
        if (res.resultModel.locationStatus == 1) {
          this.LocationOrNot = true
        } else {
          this.LocationOrNot = false
        }
        if (res.resultModel.locationStatus == 1 || this.$store.state.isAdmin) {
          this.isShowMap = true
        } else {
          this.isShowMap = false
        }
        this.getLastRealTimeData()// 获取初始化时的实时数据
      })
      getHourMeterTotalTime({ mcuId: this.$route.query.mcuId }).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        this.basic.IgnitionTime = Math.floor(res.resultModel.ignitionTime / 60000)
        this.basic.hourMeterTime = Math.floor(res.resultModel.hourMeterTime / 60000)
        this.basic.IgnitionTimeZh = usedTime(res.resultModel.ignitionTime, 'noSecond')
        this.basic.hourMeterTimeZh = usedTime(res.resultModel.hourMeterTime, 'noSecond')
      })
    },
    getLastRealTimeData() { // 获取初始化时的实时数据
      getLastRealTimeData({ mcuId: this.$route.query.mcuId }).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        this.batteryInfo.batteryVoltage = res.resultModel.voltageRaw ? res.resultModel.voltageRaw / 100 : 0
        this.batteryInfo.soc = res.resultModel.soc ? Math.round(res.resultModel.soc / 100) : 0
        this.batteryInfo.level = res.resultModel.level
        this.batteryInfo.remainingAvailableTime = res.resultModel.remainingAvailableTime
        var cur = res.resultModel.currentCharging - res.resultModel.currentUsing
        this.batteryInfo.current = cur ? (cur / 100).toFixed(2) : 0
        if (cur == 0) {
          this.batteryStatus = 0// 静止
        } else { // 充电、放电 // 0静止，1充电，2放电
          this.batteryStatus = cur > 0 ? 1 : 2
        }
        this.batteryInfo.batteryTmp = res.resultModel.batteryTemperature ? Math.round(res.resultModel.batteryTemperature / 100) : 0
        this.batteryInfo.auxBatVol = res.resultModel.auxBatVol ? res.resultModel.auxBatVol / 100 : 0
        // console.log('this.batteryInfo', this.batteryInfo)
        this.updateTime = res.resultModel.yhubStimeTs ? res.resultModel.yhubStimeTs : null
        this.basic.Ignition = res.resultModel.ignitionVol > this.basicinfo.openIgnitionVol ? i18n.t('location.enable') : i18n.t('location.disable')// 'ON' : 'OFF'
        this.basic.hourMeter = res.resultModel.hourMeterVol > this.basicinfo.workHourmeterVol ? i18n.t('location.enable') : i18n.t('location.disable')// 'ON' : 'OFF'
        this.batteryInfo.openIgnitionVol = this.basicinfo.openIgnitionVol// 阈值
        this.batteryInfo.Ignition = res.resultModel.ignitionVol // 真实值
        this.batteryInfo.workHourmeterVol = this.basicinfo.workHourmeterVol// 阈值
        this.batteryInfo.hourMeter = res.resultModel.hourMeterVol // 真实值
        if (res.resultModel.yhubStimeTs) this.basic.AnalogTime = howLongAgo(res.resultModel.yhubStimeTs, 'noSecond')
      })
    },
    popInit() { // 编辑基本信息弹窗--初始化
      // 编辑设备信息弹窗--设备类型多选框
      sysDictInfo().then(res => {
        res.resultModel.forEach(v => {
          this.deviceTypeOptions.push({
            label: v.name,
            value: v.k,
            disabled: false
          })
        })
      })
      // 编辑设备信息弹窗--归属公司下拉框
      listByCompanyParentId({
        companyParentId: this.$store.state.company.id
      }).then(response => {
        if (response.resultCode == 1001) {
          this.companyOptions = []
          if (response.resultModel && response.resultModel.length > 1) {
            this.haveChildCompany = true
          } else {
            this.haveChildCompany = false
          }
          response.resultModel.forEach(v => {
            if (v.companyName) { this.companyOptions.push({ label: v.companyName, key: v.id }) }
          })
          this.companyOptionsFun()
        }
      })
      // 编辑基本信息弹窗--电池型号下拉框
      cascader().then(response => {
        this.options2 = response.resultModel
      })
      machineTypeList().then(res => { // 类型
        if (res.resultCode == 1001) {
          res.resultModel.forEach(v => {
            this.machineTypeOptions = res.resultModel || []
          })
        }
      })
    },
    getMechBrand() { // 获取品牌
      this.machineBrandOptions = []
      deviceMechcascader().then((res) => { // 品牌
        if (res.resultCode == 1001 && res.resultModel) {
          res.resultModel.forEach(v => {
            this.machineBrandOptions.push({ value: v.label })
          })
        }
      })
    },
    queryMechBrand(queryString, cb) {
      var machineBrandOptions = this.machineBrandOptions
      var results = queryString ? machineBrandOptions.filter(this.createFilter(queryString)) : machineBrandOptions
      cb(results)
    },
    companyOptionsFun() {
      var sessionCompany = JSON.parse(sessionStorage.getItem('companyInfo'))
      // 将归属公司转拼音进行排序
      this.companyOptions.forEach(v => {
        if (v.label[0] >= 'a' && v.label[0] <= 'z') {
          v.namePinyin = vPinyin.chineseToPinYin(v.label.toUpperCase())
        } else {
          v.namePinyin = vPinyin.chineseToPinYin(v.label)
        }
      })
      this.companyOptions.sort(arrObjSort('namePinyin'))
      var hadSelfCompany = false // 是否包含自己所在公司。因为受域名限制，可能不展示自己所在公司
      // 排序后，自己公司可能不在首位，所以先删除，再添加
      this.companyOptions.forEach((v, i) => {
        if (v.key == sessionCompany.id) {
          hadSelfCompany = true
          this.companyOptions.splice(i, 1)
        }
      })
      if (hadSelfCompany) {
        this.companyOptions.unshift({
          label: sessionCompany.companyName,
          key: sessionCompany.id
        })
      }
    },
    gotoFeedBack() { // 去问题反馈页
      var routeData = this.$router.resolve({
        path: '/feedBack/feedBackIndex',
        query: {
          sn: this.$route.query.sn
        }
      })
      window.open(routeData.href, '_self')
    },
    showEditBasicinfoPop() {
      // 编辑基本信息弹窗--显示
      this.editBasicinfoPop = true
      this.getCity()
      this.getMechBrand()
      getLastOne({ mcuId: this.$route.query.mcuId }).then(res => {
        if (res.resultCode == 1001) {
          if (!res.resultModel) {
            this.batteryCascader = [
              '_1',
              {
                batteryAh: 225,
                batterySystemVolt: 24,
                batteryBrand: 'Trojan',
                batteryModel: 'T105',
                id: 2
              }
            ]
            this.batteryModelChange()
          } else {
            var jsonData = JSON.parse(res.resultModel.jsonData)
            console.log(jsonData)
            if (jsonData.sd_battery) { this.editBasicinfo.batteryId = jsonData.sd_battery.battery_id }
            this.editBasicinfo.batteryCapacity = Math.round(jsonData.battery_totalAh / 100)
            this.editBasicinfo.batteryVoltage = jsonData.battery_system_volt > 1000 ? Math.round(jsonData.battery_system_volt / 100) : jsonData.battery_system_volt
            this.batteryCascader = [
              '_1',
              {
                batteryAh: this.editBasicinfo.batteryCapacity,
                batteryBrand: res.resultModel.batteryBrand,
                batteryModel: res.resultModel.batteryModel,
                id: this.editBasicinfo.batteryId
              }
            ]
            this.batteryModelChange()
          }
          this.editBasicinfo.deviceSn = this.basicinfo.deviceSn
          this.findPC = i18n.t('allDeviceDetail.findPC1') + this.basicinfo.deviceSn + i18n.t('allDeviceDetail.findPC2')
          this.editBasicinfo.mcuId = this.$route.query.mcuId
          this.editBasicinfo.deviceName = this.editBasicinfo.deviceName1 = this.basicinfo.deviceName
          if (!this.editBasicinfo.locationSample) { this.editBasicinfo.locationSample = 30 }
        }
      })
      this.editBasicinfo.cell = this.basicinfo.cell
      this.editBasicinfo.mechBrand = this.basicinfo.mechBrand
      this.editBasicinfo.mechType = this.basicinfo.mechType
      this.editBasicinfo.mechModel = this.basicinfo.mechModel
      this.editBasicinfo.mechId = this.basicinfo.mechId
      this.editBasicinfo.deviceName = this.basicinfo.deviceName
      this.editBasicinfo.company = this.basicinfo.companyId
      this.editBasicinfo.resetTime = this.basicinfo.createTime
      this.editBasicinfo.hourMeterStatus = this.basicinfo.hourMeterStatus == 1
      this.editBasicinfo.workHourmeterVol = this.basicinfo.workHourmeterVol
      this.editBasicinfo.openIgnitionVol = this.basicinfo.openIgnitionVol
      var hadThisCompany = this.companyOptions.some(v => { return v.key == this.basicinfo.companyId })
      // 当公司id不在this.companyOptions中，即公司为所在公司的子公司的子公司，且登录用户无admin权限
      if (!hadThisCompany) {
        this.editBasicinfo.companyId = this.basicinfo.companyId
        this.editBasicinfo.company = this.basicinfo.companyName
      }
      this.editBasicinfo.resetTime = this.createTime
    },
    getLastOne() {
      getLastOne({ mcuId: this.$route.query.mcuId }).then(res => {
        if (res.resultCode == 1001) {
          if (res.resultModel && res.resultModel.jsonData) {
            var jsonData = JSON.parse(res.resultModel.jsonData)
            if (!jsonData.extral_funtion)jsonData.extral_funtion = 0
            var extralArr2 = this.decimalToBinary(jsonData.extral_funtion, 2)
            this.communication485 = extralArr2[3] === 1 ? 2 : 1 // 判断485模块是否展示 2展示 1不展示
          }
        }
      })
    },

    decimalToBinary(num, digits) { // 十进制转二进制  digits:代表传过来的是几位数，避免用<10判断出错，如：01 本应该转成8位，却转成了4位
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (!digits || digits == 1) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
      // } else if (myNum >= 10 && myNum < 100) {
      } else if (digits == 2) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
    },
    batteryModelChange(value) {
      // 添加设备--电池型号选中
      if (!value) {
        value = this.batteryCascader
      }
      this.batteryModelObj = value[1]
      if (!value[1].batteryAhC5) { this.disabledC5 = true } else { this.disabledC5 = false }
      this.editBasicinfo.batteryCapacity = value[1].batteryAh
      this.editBasicinfo.batteryId = value[1].id
      this.editBasicinfo.batteryBrand = value[1].batteryBrand
      this.editBasicinfo.batteryModel = value[1].batteryModel
      this.isShowBatteryModelWarning = false
    },
    changeC520(val) {
      if (this.batteryModelObj.batteryAh) {
        this.editBasicinfo.batteryTotalah = val == 5 ? this.batteryModelObj.batteryAhC5 : this.batteryModelObj.batteryAh
      }
    },
    change(e) {
      this.$forceUpdate()
    },
    mouseoverQuestion(index) {
      document.querySelectorAll('.questionPop')[index].style.display = 'block'
    },
    mouseoutQuestion(index) {
      document.querySelectorAll('.questionPop')[index].style.display = 'none'
    },
    sensorTypeChange() {
      // 编辑基本信息弹窗--电流计类型选中
      switch (this.editBasicinfo.sensorType) {
        case '1': this.isShowHallDetail = true; break
        case 1: this.isShowHallDetail = true; break
        default: this.isShowHallDetail = false; break
      }
    },
    submitBasicinfo(formName) {
      // 编辑基本信息弹窗--提交
      var param = {
        id: this.basicinfo.id,
        mechId: this.editBasicinfo.mechId,
        mcuId: this.$route.query.mcuId,
        companyName: this.editBasicinfo.companyName,
        companyId: this.editBasicinfo.company,
        deviceName: this.editBasicinfo.deviceName,
        deviceSn: this.editBasicinfo.deviceSn,
        batteryModel: this.editBasicinfo.batteryModel,
        batterySystemVolt: this.editBasicinfo.batteryVoltage,
        batteryTotalah: this.editBasicinfo.batteryCapacity * 100,
        locationStatus: '',
        cell: this.editBasicinfo.cell,
        openIgnitionVol: this.editBasicinfo.openIgnitionVol,
        workHourmeterVol: this.editBasicinfo.workHourmeterVol,
        machineBrand: this.editBasicinfo.mechBrand,
        machineType: this.editBasicinfo.mechType,
        machineModel: this.editBasicinfo.mechModel,
        site: this.editBasicinfo.site
      }
      if (!this.LocationOrNot) {
        param.locationStatus = 0
      } else {
        param.locationStatus = 1
      }
      param.showAvailableTime = this.editBasicinfo.showAvailableTime == true ? 1 : 0
      param.hourMeterStatus = this.editBasicinfo.hourMeterStatus == true ? 1 : 0
      param.halfV = this.editBasicinfo.halfV == true ? 1 : 0

      var hadThisCompanyId = this.companyOptions.some(v => { return this.editBasicinfo.company == v.key })
      // 当公司this.editBasicinfo.company不在this.companyOptions中，即公司为所在公司的子公司的子公司，且登录用户无admin权限
      if (!hadThisCompanyId) {
        param.companyId = this.basicinfo.companyId
      }
      // if (!this.editBasicinfo.batteryId) {
      //   this.isShowBatteryModelWarning = true
      //   // this.$message.error('请选择型号')
      //   return
      // }
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editBasicinfo.deviceName) {
            // 去掉首尾空格
            this.editBasicinfo.deviceName = this.editBasicinfo.deviceName.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
          }
          if (!this.editBasicinfo.deviceName) {
            this.$message({
              type: 'success',
              message: i18n.t('allDeviceDetail.DeviceNameCannotEmpty')
            })
            return
          }
          updateDeviceBindBase(param).then(response => {
            if (response.resultCode === 1001) {
              this.$message({
                type: 'success',
                message: 'Succeed!'
              })
              this.editBasicinfoPop = false
              this.queryList()
            } else {
              this.$message({
                type: 'error',
                message: response.resultMessage
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    showUpdateTimePop() {
      // 编辑重置时间弹窗--显示
      // this.editUpdateTimePop = true
      this.editUpdateTime.createTime = this.createTime
      this.editUpdateTime.updateTime = getDateAndHour(new Date().getTime(), 'noTime')
      this.$alert(i18n.t('BondOrUpdateDevice.ResetBindingTime'), '', {
        confirmButtonText: i18n.t('button.Confirm'),
        callback: action => {
          if (action == 'confirm') {
            this.submitUpdateTime()
          }
        }
      })
    },
    submitUpdateTime(formName) {
      // 编辑重置时间弹窗--提交
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      addDeviceReset({ mcuId: this.$route.query.mcuId }).then(response => {
        if (response.resultCode === 1001) {
          this.$message({
            type: 'success',
            message: 'Succeed!'
          })
          this.editUpdateTimePop = false
        }
        this.createTime = getDateAndHour(new Date().getTime(), 'noTime')
        this.editBasicinfo.resetTime = getDateAndHour(new Date().getTime(), 'noTime')
        this.basicinfo.lastUpdateTime = howLongAgo2(new Date().getTime())
        // this.queryList()
      })
      // } else {
      //   console.log('error submit!!')
      //   return false
      // }
      // })
    },
    restoreFactorySet() {
      // 恢复出厂设置
      this.restoreFactorySetPop = true
    },
    blurPasscode() {
      if (this.restoreFactorySetInfo.passcode) {
        this.isShowResFacSetInfoPasscode = false
      } else {
        this.isShowResFacSetInfoPasscode = true
      }
    },
    submitRestoreFactorySet() {
      if (!this.restoreFactorySetInfo.passcode) {
        this.isShowResFacSetInfoPasscode = true
        return
      }
      this.$confirm(i18n.t('allDeviceDetail.confirmReset'), '', {
        // '是否恢复出厂设置?'
        confirmButtonText: i18n.t('button.Confirm'), // '确定',
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      })
        .then(() => {
          var param = {
            // 'mcuId': '05d6ff393430475043165127',
            // 'pc': 518386
            mcuId: this.$route.query.mcuId,
            pc: this.restoreFactorySetInfo.passcode
          }
          // console.log(param)
          addDeviceAllReset(param).then(res => {
            if (res.resultCode == 1001) {
              this.restoreFactorySetPop = false
              this.$message({
                type: 'success',
                message: i18n.t('allDeviceDetail.resetSucceed') // '重置成功!'
              })
            } else {
              this.$message({
                type: 'error',
                message: i18n.t('allDeviceDetail.resetFailed') // '重置失败!'
              })
            }
          })
        })
        .catch(() => {})
    },
    getCity() { // 获取已有的地址
      this.allCity = []
      getCompanySiteList().then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.forEach(v => {
          this.allCity.push({ value: v })
        })
      })
    },
    querySearchCity(queryString, cb) {
      var allCity = this.allCity
      var results = queryString ? allCity.filter(this.createFilter(queryString)) : allCity
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    handleSelect(item) {
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.changePieBtn{
  outline: none;    //消除默认点击蓝色边框效果
  height: 25px;
  padding: 0 10px;
  font-size: 14px;
  border-radius: 4px;
  border:1px solid #c2e7b0;
  background:#f0f9eb;
  margin-bottom: 10px;
  position: relative;
  margin-left: calc(1% + 5px);
}
.active{
  border:1px solid #67c23a;
  background:#67c23a;
  color:white;
}
.card-panel {
  padding-bottom: 20px;
}
.questionPop {
  display: none;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  bottom: 165px;
  left: 10px;
  max-width: 100%;
}
.blockContentDiv {
  padding: 0 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.deviceInfoChart {
  width: 49%;
  display: inline-block;
  // border:1px solid red;
  height: 250px;
}
.deviceInfoDetail {
  width: 100%;
  // border:1px solid red;
}
.deviceInfoDetailP {
  line-height: 32px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.noHourMeter .deviceInfoDetailP{
  line-height: 43px;
}
.deviceInfoDetailBtn {
  position: absolute;
  right: 0;
}
.statusContentWarp {
  height: 100%;
  // border:1px solid red;
}
.warningWrap {
  // height: 250px;
  padding: 15px 5%;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  // justify-content: space-around;
  text-align: center;
  overflow-y: auto;
}
.warningDivs {
  display: inline-block;
}
.warningImg {
  width: 70px;
  height: 70px;
  display: inline-block;
}
.redWarningRadiu {
  font-size: 20px;
  margin-top: 5px;
  width: 10px;
  height: 10px;
  display: inline-block;
  position: absolute;
  z-index: 200;
  background: red;
  border-radius: 50%;
  // left: calc(50% + 15px);
  // top: 0px;
  right: 18px;
  top: 2px;
}
.AnalogContentWarp{
  display: flex;
  // justify-content: space-between;
}
.feedBackBtn{
  position: absolute;
  right:90px;
  background: #f0bd29;
  border: 1px solid #f0bd29;
}
</style>
<style lang="scss">
#allDeviceDetail {
  .el-form-item {
    width: 100%;
    position: relative;
  }
  .el-form-item__content {
    width: calc(100% - 180px);
  }
  #editBasicinfoPop .el-autocomplete,
  #editBasicinfoPop .el-cascader--medium,
  #editBasicinfoPop .el-input {
    width: 100% !important;
  }
  #editBasicinfoPop .ycdd .el-input {
    width: 80px !important;
    margin-right: 10px;
  }
  #editBasicinfoPop .ycdd .el-input__inner {
    padding: 0 10px;
  }
  .el-dialog {
    // margin-top: 5vh !important;
  }
  .el-select {
    width: 100%;
  }
  .el-select-dropdown__item.selected {
    color: #606266;
    font-weight: normal;
  }
  .setting .el-form-item__label {
    color: #1990fc;
  }
  .el-row {
    // padding-right: 30px;
  }
  .cellNumberInfoPop{
    display: inline-block;
    background: white;
    padding: 14px;
    vertical-align: top;
    box-shadow: 1px 1px 5px #ccc;
    position: absolute;
    z-index: 999;
    bottom: 64px;
    max-width: 100%;
    right: 0;
    width: auto;
  }
  .cellNumber{
    position: relative;
  }
  .cellNumber .el-icon-question{
    position: absolute;
    top: 7px;
    font-size: 18px;
    color: #858585;
    z-index: 999;
    right: -20px;
  }
}
</style>

